import { render, staticRenderFns } from "./CustomOrderPreview.vue?vue&type=template&id=4ceebd70"
import script from "./CustomOrderPreview.vue?vue&type=script&lang=js"
export * from "./CustomOrderPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports